<template>
  <svg
    class="site_logo"
    :style="logoStyle"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 292 40.07"
    aria-hidden="true"
  >
    <polygon
      points="275.3 40.07 278.99 40.07 278.99 22.59 292 0 287.74 0 277.15 18.41 266.55 0 262.29 0 275.3 22.59 275.3 40.07"
      fill="currentColor"
    />
    <polygon
      points="228.51 40.07 232.2 40.07 232.2 3.69 245.52 3.69 245.52 0 215.2 0 215.2 3.69 228.51 3.69 228.51 40.07"
      fill="currentColor"
    />
    <rect x="188.56" width="3.69" height="40.07" fill="currentColor" />
    <polygon
      points="164.41 40.07 164.41 36.42 143.22 36.42 143.22 0 139.53 0 139.53 40.07 164.41 40.07"
      fill="currentColor"
    />
    <polygon
      points="92.84 40.07 105.27 9.8 118.05 40.07 122.04 40.07 105.22 0 88.86 40.07 92.84 40.07"
      fill="currentColor"
    />
    <polygon
      points="72.57 40.07 72.57 36.45 51.51 36.45 51.51 22.52 72.57 22.52 72.57 18.86 51.51 18.86 51.51 3.66 72.57 3.66 72.57 0 47.82 0 47.82 40.07 48.25 40.07 72.57 40.07"
      fill="currentColor"
    />
    <path
      d="M3.69,40.07V3.62h11a10,10,0,1,1,0,20.07H10.82l.46.51L25.76,40.07H30.7L18.6,26.71h0A13.64,13.64,0,0,0,14.79,0H0V40.07Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SiteLogo extends Vue {
  @Prop({ default: 20 })
  height!: number

  @Prop({ default: '#0f0f0f' })
  color!: string

  get logoStyle() {
    return {
      height: `${this.height}px`,
      color: this.color,
    }
  }
}
</script>

<style scoped>
.site_logo {
  display: block;
  width: auto;
}
</style>
